var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"proximos-partidos"},[_c('proximos-partidos-titulo'),_c('div',{staticClass:"proximos-partidos__title"}),_c('div',{staticClass:"proximos-partidos__content"},_vm._l((_vm.nextMatches),function(match){return _c('proximo-partido',{key:match.id,attrs:{"match":match}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }